import { WeekDayEnum } from '@api/models/week-day-enum';

export const WEEK_DAYS = [
  { id: WeekDayEnum.Monday, name: 'M', tooltip: 'global.daysFullName.monday' },
  { id: WeekDayEnum.Tuesday, name: 'T', tooltip: 'global.daysFullName.tuesday' },
  { id: WeekDayEnum.Wednesday, name: 'W', tooltip: 'global.daysFullName.wednesday' },
  { id: WeekDayEnum.Thursday, name: 'T', tooltip: 'global.daysFullName.thursday' },
  { id: WeekDayEnum.Friday, name: 'F', tooltip: 'global.daysFullName.friday' },
  { id: WeekDayEnum.Saturday, name: 'S', tooltip: 'global.daysFullName.saturday' },
  { id: WeekDayEnum.Sunday, name: 'S', tooltip: 'global.daysFullName.sunday' },
];

enum EventColors {
  Blue = '#1f5792',
  Green = '#6a994e',
  Red = '#E9190F',
  Yellow = '#FFAE03',
  Orange = '#F38221',
  Brown = '#99582a',
}

export enum EventColorsIdEnum {
  Blue = 1,
  Green = 2,
  Red = 3,
  Yellow = 4,
  Orange = 5,
  Brown = 6,
}

export const EVENT_COLORS = [
  { id: EventColorsIdEnum.Blue, name: 'global.colors.blue', hexCode: EventColors.Blue },
  { id: EventColorsIdEnum.Green, name: 'global.colors.green', hexCode: EventColors.Green },
  { id: EventColorsIdEnum.Red, name: 'global.colors.red', hexCode: EventColors.Red },
  { id: EventColorsIdEnum.Orange, name: 'global.colors.orange', hexCode: EventColors.Orange },
  { id: EventColorsIdEnum.Yellow, name: 'global.colors.yellow', hexCode: EventColors.Yellow },
  { id: EventColorsIdEnum.Brown, name: 'global.colors.brown', hexCode: EventColors.Brown },
];

export const EVENT_COLOR_HEX_BY_ID: Record<number, string> = Object.fromEntries(EVENT_COLORS.map(color => [color.id, color.hexCode])) as Record<
  number,
  string
>;
